<template>
  <table class="table is-fullwidth">
    <tr class="has-text-white-ter">
      <template v-for="item of data">
        <td
          v-if="item.percent !== 0"
          :key="item.css + item.percent"
          class="is-paddingless has-text-centered tooltip"
          :class="item.css"
          :style="`width:${item.percent}%`"
          :data-tooltip="item.text"
        >
          {{ item.percent }}%
        </td>
      </template>
    </tr>
  </table>
</template>

<script>
export default {
  props: { data: Array }
};
</script>

<style lang="css" scoped>
table {
  border-collapse: collapse;
}
td {
  padding: 2px !important;
  padding-right: 6px !important;
  padding-left: 6px !important;
  margin: 0px;
  border: none;
  transition: width 2s;
}

tr {
  font-size: 12px;
  height: 10px;
}

table tr:last-child td:first-child {
  border-top-left-radius: 290486px;
  border-bottom-left-radius: 290486px;
}

table tr:last-child td:last-child {
  border-top-right-radius: 290486px;
  border-bottom-right-radius: 290486px;
}
</style>
